import Image from '@atlaskit/image';
import { Box, xcss } from '@atlaskit/primitives';
import { css } from '@compiled/react';

import {
	COPY_LIST_SETTINGS_NO,
	COPY_LIST_SETTINGS_MIGRATE_ALL_SPACES,
} from '../placements/in-app-v2/issue-navigator-placement/constants';
import singleProjectListMergeAnimationDark from '../assets/list-merge-modal-single-project-dark.gif';
import singleProjectListMergeAnimation from '../assets/list-merge-modal-single-project-light.gif';
import multiProjectListMergeAnimationDark from '../assets/list-merge-modal-multi-project-dark.png';
import multiProjectListMergeAnimation from '../assets/list-merge-modal-multi-project-light.png';
import noListPreferenceListMergeIllustrationDark from '../assets/list-merge-modal-button-dark.png';
import noListPreferenceListMergeIllustration from '../assets/list-merge-modal-button-light.png';
import { messages } from './messages';

const MIN_WIDTH = 531;

const imageStyles = xcss({
	overflow: 'hidden',
	position: 'relative',
	width: '100%',
});

const onboardingImageStyles = css({
	width: '100%',
	minWidth: `${MIN_WIDTH}px`,
});

type ModalOnboardingImageProps = {
	copyListSettings: string;
};

export const ModalOnboardingImage = ({ copyListSettings }: ModalOnboardingImageProps) => {
	let listMergeAnimation;
	let listMergeAnimationDark;
	let imageAltText;

	switch (copyListSettings) {
		case COPY_LIST_SETTINGS_MIGRATE_ALL_SPACES:
			listMergeAnimation = multiProjectListMergeAnimation;
			listMergeAnimationDark = multiProjectListMergeAnimationDark;
			imageAltText = messages.copyListSettingsImageAltText.defaultMessage;
			break;
		case COPY_LIST_SETTINGS_NO:
			listMergeAnimation = noListPreferenceListMergeIllustration;
			listMergeAnimationDark = noListPreferenceListMergeIllustrationDark;
			imageAltText = messages.copyListSettingsImageAltTextNo.defaultMessage;
			break;
		default:
			listMergeAnimation = singleProjectListMergeAnimation;
			listMergeAnimationDark = singleProjectListMergeAnimationDark;
			imageAltText = messages.copyListSettingsImageAltTextCurrentSpace.defaultMessage;
	}

	return (
		<Box xcss={imageStyles}>
			<Image
				css={onboardingImageStyles}
				src={listMergeAnimation}
				srcDark={listMergeAnimationDark}
				alt={imageAltText}
			/>
		</Box>
	);
};
